import React from 'react'
import PropTypes from 'prop-types'

import { Typography } from '@material-ui/core'

import QuotesIcon from 'images/ecom/quotes.svg'

import {
  ContentBox,
  ContentGrid,
  GridContainer,
  ImageBox,
  QuotesIconBox,
  UserDetailsBox,
  UserInfoBox,
  UserNameBox,
} from './Testimonial.style'

const Testimonial = ({ quote, imageSrc, imageBgPosition, user, classes = {} }) => {
  return (
    <GridContainer>
      <ContentGrid>
        <ContentBox>
          <QuotesIconBox>
            <img src={QuotesIcon} alt='' />
          </QuotesIconBox>
          <Typography variant='body1'>{quote}</Typography>
          <UserInfoBox className={classes.userInfo}>
            <UserDetailsBox>
              {user.src && <img src={user.src} width={52} height={52} alt='Customer Avatar' />}
              <UserNameBox className={classes.userName}>
                <Typography variant='subtitle2' className={classes.name}>
                  {user.name}
                  {user.address && ','}
                </Typography>
                {user.address && <Typography variant='caption'>{user.address}</Typography>}
              </UserNameBox>
            </UserDetailsBox>
          </UserInfoBox>
        </ContentBox>
      </ContentGrid>
      <ImageBox imageSrc={imageSrc} imageBgPosition={imageBgPosition} />
    </GridContainer>
  )
}

Testimonial.propTypes = {
  quote: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  imageBgPosition: PropTypes.shape({
    xs: PropTypes.string,
    sm: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string,
    address: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({
    userInfo: PropTypes.string,
    userName: PropTypes.string,
    name: PropTypes.string,
  }),
}
export default Testimonial
